'use strict'

const PersistentStore = (store) => {
}

module.exports = PersistentStore



// WEBPACK FOOTER //
// ./src/utils/PersistentStore.js